import React, { useEffect, useRef, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import { useSelector } from 'react-redux'

import { newDeviceInfo } from '../../../tools/mockData'
import { UPDATE_KEY_MAPPINGS_PERMISSION } from '../../redux/actions/actionTypes'
import { updateKeyMapping } from '../../redux/actions/keyMappingActions'
import { store, useAppDispatch } from '../../redux/configureStore'
import { IRootState } from '../../redux/reducers'
import { DeviceKeyMappingInfo } from '../../redux/reducers/initialState'
import { usePermissions } from '../common/permission/usePermissions'

import KeyMappingForm from './KeyMappingForm'

type EditKeyMappingPageProps = {
  match: any
  history: any
}

const EditKeyMappingPage = ({ match, history }: EditKeyMappingPageProps) => {
  const keyMappings: DeviceKeyMappingInfo[] = useSelector(
    (state: IRootState) =>
      state.keyMappings != null &&
      state.keyMappings.deviceKeyMappings.length !== 0
        ? state.keyMappings.deviceKeyMappings
        : [],
  )

  if (keyMappings.length === 0) {
    history.push('/')
  }

  const dispatch = useAppDispatch()
  const { checkPermissions } = usePermissions()
  const [entity, setEntity] = useState<DeviceKeyMappingInfo>(newDeviceInfo)
  const [formReady, setFormReady] = useState(false)
  const [showModal, setShowModal] = useState(true)
  const [dataChanged, setDataChanged] = useState(false)
  const handleCancel = () => setShowModal(false)
  const formRef: any = useRef()

  useEffect(() => {
    const rowEntity = keyMappings.find(
      (entity) => entity.rowKey === match.params.slug,
    )

    if (rowEntity) setEntity(rowEntity)
  }, [])

  const handleOk = () => {
    formRef.current.validate()
    if (!formReady || !entity) return

    checkPermissions(store.getState(), UPDATE_KEY_MAPPINGS_PERMISSION)
    dispatch(updateKeyMapping(entity))
    history.push('/keymappings')
  }

  const handleExited = () => {
    history.push('/keymappings')
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleCancel}
        onExited={handleExited}
        backdrop="static"
        keyboard={false}
      >
        <div className="container">
          <Modal.Header className="responsive-button" closeButton>
            <Modal.Title>Edit Permission</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <KeyMappingForm
              ref={formRef}
              entityData={entity}
              setEntityData={setEntity}
              setFormReady={setFormReady}
              setDataChanged={setDataChanged}
              disabled={{ deviceId: true }}
            />
          </Modal.Body>

          <Modal.Footer>
            <button
              className="responsive-button btn btn-secondary"
              onClick={handleCancel}
            >
              Close
            </button>
            <button
              disabled={!dataChanged}
              className="responsive-button btn btn-primary"
              onClick={handleOk}
            >
              Save
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  )
}

export default EditKeyMappingPage
